const module = {
  config: {
    name: "grower-activity",
    icon: "dashboard",
    desc: "Data Utama untuk pengelolaan Project pada Aplikasi",
    layout: true,
    order: 1
  },
  routes: [
    // farmers
    {
      name: 'grower',
      icon: 'body-scan',
      path: '/grower',
      translate_key: 'grower',
      component: () => import('./farmers/farmers.vue'),
      separator: ""
    },
    // lahans
    {
      name: 'lahans',
      icon: 'collage-line',
      path: '/lahans',
      translate_key: 'lahans',
      component: () => import('./lahans/lahans.vue'),
      separator: ""
    },
    // projects
    {
      name: 'projects',
      icon: 'plant',
      path: '/projects',
      translate_key: 'projects',
      component: () => import('./projects/projects.vue'),
      separator: ""
    },
    // donors
    {
      name: 'donors',
      icon: 'group-2',
      path: '/donors',
      translate_key: 'participants',
      component: () => import('./participants/participants.vue'),
      separator: ""
    },
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/main-data/_index.js